<template>
  <div class="introduce">
    <div class="title">
      <h2 class="about">{{ service.title }}</h2>
      <span class="motto">
        {{ service.slogan }}
      </span>
    </div>
    <div class="info">
      <img :src="service.url" :alt="service.slogan" />
      <div class="info-right">
        <p v-html="service.content"></p>
      </div>
    </div>
  </div>
</template>

<script>
import HomeApi from '../../network/home'
import { program_type, content_type } from '../../common/enum/imgEnum'

export default {
  name: 'Introduce',
  data() {
    return {
      service: {}
    }
  },
  async created() {
    await this._selectService()
  },
  methods: {
    /**
     * 获取服务范围
     * @returns {Promise<void>}
     * @private
     */
    async _selectService() {
      const result = await HomeApi.getContent(
        program_type.common,
        content_type.homeService
      )
      this.service = result.data[0]
    }
  }
}
</script>

<style scoped>
.introduce {
  margin-top: 150px;
}

.title {
  text-align: center;
}

.about {
  font-weight: bolder;
  font-size: 40px;
  height: 20px;
  color: #ffffff;
}

.motto {
  padding-top: 20px;
  line-height: 80px;
  height: 80px;
  font-size: 20px;
  border-top: 1px solid #a9a9a9;
}

.info {
  margin-top: 60px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.info > div > p {
  padding-left: 55px;
  word-spacing: 20px;
  line-height: 23px;
  top: 100px;
  font-weight: 550;
  font-size: 14px;
}

.info-right {
  display: flex;
  align-items: center;
  text-align: justify;
}

.info > img {
  width: 100%;
}
</style>
